class ApiService {
  constructor(baseURL) {
    this.baseURL = baseURL;
    this.requestInterceptor = null;
    this.responseInterceptor = null;
    this.errorInterceptor = null;
  }

  async request(
    endpoint,
    method = "GET",
    body = null,
    params = {},
    headers = {}
  ) {
    if (this.requestInterceptor) {
      this.requestInterceptor();
    }

    const url = new URL(`${this.baseURL}${endpoint}`);
    const token = localStorage.getItem("token");

    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );

    const config = {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
        ...headers,
      },
    };

    if (body) {
      config.body = JSON.stringify(body);
    }

    try {
      const response = await fetch(url, config);

      if (!response.ok) {
        const errorData = await response.json();
        // const errorMessage =
        // errorData.message || `Request failed with status ${response.status}`;
        const errorMessage =
          response.status === 500
            ? "This email or username is already registered!"
            : "Invalid credentials!";

        throw new Error(errorMessage);
      }

      const responseData = await response.json();

      if (this.responseInterceptor) {
        return this.responseInterceptor(responseData);
      }

      return responseData;
    } catch (error) {
      if (this.errorInterceptor) {
        console.error("Intercept Error ---> ", this.errorInterceptor);

        if (typeof localStorage !== "undefined") {
          localStorage.removeItem("token");
        }

        this.errorInterceptor(error);
      } else {
        console.error("Generic Error ---> ", error.message);
        throw error;
      }
    } finally {
      if (this.requestInterceptor) {
        this.requestInterceptor(false);
      }
    }
  }

  get(endpoint, params = {}, headers = {}) {
    return this.request(endpoint, "GET", null, params, headers);
  }

  post(endpoint, body = {}, headers = {}) {
    return this.request(endpoint, "POST", body, {}, headers);
  }

  put(endpoint, body = {}, headers = {}) {
    return this.request(endpoint, "PUT", body, {}, headers);
  }

  delete(endpoint, headers = {}) {
    return this.request(endpoint, "DELETE", null, {}, headers);
  }

  interceptRequests(onRequestStart, onRequestEnd, onError) {
    this.requestInterceptor = (start = true) => {
      if (start) onRequestStart();
      else onRequestEnd();
    };

    this.responseInterceptor = (response) => {
      onRequestEnd();
      return response;
    };

    this.errorInterceptor = (error) => {
      onRequestEnd();
      onError(error.message);
      return Promise.reject(error);
    };
  }

  removeInterceptors() {
    this.requestInterceptor = null;
    this.responseInterceptor = null;
    this.errorInterceptor = null;
  }
}

export default new ApiService(process.env.REACT_APP_API_URL);
